const NavigatorUtils = require('../navigatorUtils');
const { summary } = require('./scriptSizeCollector');
const { isSafariOrIOS } = require('../../utils/browserUtils');

class JSLoadTracker {
    _lastSentFirstPartySize = null;
    constructor(tracking) {
        this._tracking = tracking;
    }

    registerUnloadEvents() {
        if (isSafariOrIOS()) {
            return;
        }
        window.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
                this._trackCollectedMetrics();
            }
        });
        // NOTE: Safari does not reliably fire the `visibilitychange` event when the
        // page is being unloaded. If Safari support is needed, you should also flush
        // the queue in the `pagehide` event.
        if (!NavigatorUtils.isVisibilitychangeFullySupported()) {
            window.addEventListener('pagehide', () => {
                this._trackCollectedMetrics();
            });
        }
    }

    _trackCollectedMetrics() {
        const jsLoadMetrics = summary();
        if (jsLoadMetrics.firstPartyTotal.size === this._lastSentFirstPartySize) {
            return;
        }
        this._lastSentFirstPartySize = jsLoadMetrics.firstPartyTotal.size;
        this._tracking.track('Js Load Metrics Captured', { jsLoadMetrics });
    }
}

module.exports = JSLoadTracker;
